export default "__VITE_ASSET__Dbd$MweY__"